// src/styles/Theme.js
import { colors, breakpoints } from './variables';

const theme = {
  colors,
  breakpoints,
  fonts: {
    main: "'Noto Sans KR', sans-serif"
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.05)',
    medium: '0 2px 8px rgba(0, 0, 0, 0.08)',
    large: '0 12px 20px rgba(0, 0, 0, 0.1)'
  }
};

export default theme;